export interface ProjectImage {
  src: string
  alt: string
}

export interface Project {
  id: number
  slug: string
  title: string
  location: string
  description: string
  image: string
  size: 'large' | 'small' | 'wide'
  year: string
  sqft: string
  value: string
  type: string
  features?: string[]
  images: ProjectImage[]
}

export const projects: Project[] = [
  {
    id: 1,
    slug: 'highland-retreat',
    title: 'Highland Retreat',
    location: 'Post Falls, ID',
    description:
      'Custom home on Garrett Ct. in Post Falls featuring a dramatic timber-framed entry, stone and cedar exterior, vaulted great room with exposed beams and stone fireplace, designer tile work, and shiplap accent walls — 4,700 square feet of refined mountain living.',
    image:
      'https://cdn.magicpatterns.com/uploads/qfzMW8fX9N711eMuQjvdaT/image.jpg',
    size: 'large',
    year: '2024',
    sqft: '4,700',
    value: '$1.8M',
    type: 'Custom Home',
    features: [
      'Full deck drainage system',
      'Heated floor system in Master Bath',
      'Integrated backup generator system',
    ],
    images: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/bUERMJpMz38kzM8kcgS49R/0N8A8863.jpg',
        alt: 'Covered deck with cedar gable ceiling, iron chandelier, and sweeping valley panorama',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/dyTEVboPpsxckRBiot5dx4/image.jpg',
        alt: 'Aerial drone view of Highland Retreat at dusk with valley and mountain backdrop',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/2cNFD8KRYjU7sHBdbs92Vt/0N8A8609.jpg',
        alt: 'Highland Retreat exterior with stone accents, cedar gable, and sweeping driveway',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/ascLhaSzwajnUn97vKbRMy/0N8A8794.jpg',
        alt: 'Vaulted great room with cathedral windows, cedar ceiling accents, and panoramic mountain views',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/oweXUtYQsoBpoWWd6yHSyM/0N8A8627.jpg',
        alt: 'Timber-framed covered entry with stone columns and natural wood ceiling',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/e88uthDWAdW4yqMFV2kPrK/98-Oct_25_2024_08_07pm-HYUu.jpg',
        alt: 'Rear elevation during framing with exposed timber beams, upper deck, and walkout lower level',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/a26RADVxncHp4SGWxfce41/92-Oct_24_2024_10_03pm-xxXF.jpg',
        alt: 'Framing stage front exterior with ZIP sheathing, gabled rooflines, and timber entry structure',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/hFUf1vnrqZ4XnM9PJEBMa8/89-Sep_23_2024_08_46pm-qLvj.jpg',
        alt: 'Highland Retreat during framing with telehandler and crew on site',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/8mjcHkWYcbxHk4GnxJoDSP/348-Apr_07_2025_10_38pm-9gWs.jpg',
        alt: 'Great room during construction with vaulted ceiling beams, drywall, and panoramic sliding doors',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/ggr2vYEM3nMHFbChGHbztK/0N8A8650.jpg',
        alt: 'Vaulted great room with exposed wood beams, stone fireplace, and French doors',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/7Z9iTPLNKhae4Ah9KNNR4E/0N8A8777.jpg',
        alt: 'Great room stone fireplace with floating wood shelves, built-in cabinets, and valley views',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/e8MzecfywG7XHTaeFL3DFB/0N8A8737.jpg',
        alt: 'Kitchen with quartz waterfall island, navy blue base, industrial pendants, and mountain views',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/cgFH3SEWzdAt5SZ4WYQbXY/0N8A8755.jpg',
        alt: 'Kitchen with floor-to-ceiling white cabinetry, stainless steel appliances, and blue accent butler pantry',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/nnwntEDSjg2dNWwpF8uuiW/0N8A8680.jpg',
        alt: 'Primary bedroom with shiplap fireplace wall, exposed beams, and wide-plank oak floors',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/mLXkMKZs4DaYAiE4MTasUm/0N8A8692.jpg',
        alt: 'Primary bath glass shower with large-format tile and mountain views',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/nyYqik87ySuYa2s1QP8RQk/0N8A8698.jpg',
        alt: 'Freestanding soaking tub with panoramic valley and tree-line views',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/uTgaKEbJapsjwUdFoCTqY2/0N8A8668.jpg',
        alt: 'Bathroom with herringbone dark tile shower, round mirror, and walnut vanity',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/6h94h2rTupyVJiyFHehDdk/0N8A8714.jpg',
        alt: 'Walk-in closet with custom oak cabinetry, center island, and chandelier',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/ohXck9NjcQ9sVWaX9udX6y/0N8A8729.jpg',
        alt: 'Butler pantry with wine storage cubbies, oak shelving, and quartz counters',
      },
    ],
  },
  {
    id: 2,
    slug: 'geothermal-tamarack-estate',
    title: 'The Geothermal Tamarack Estate',
    location: 'Post Falls, ID',
    description:
      'Custom mountain home on Mellick Rd. featuring dramatic hillside excavation, engineered concrete foundation, and panoramic valley views — currently under construction with an expected 2026 completion.',
    image:
      'https://cdn.magicpatterns.com/uploads/qTKo374tAMCnzY2sNP1ebg/68-Aug_09_2025_02_03pm-ivcN.jpg',
    size: 'wide',
    year: '2025–26',
    sqft: '5,000',
    value: '$1.6M',
    type: 'Custom Home',
    features: [
      "20' Vaulted Great Room",
      'Microcement master bath',
      'Custom lighting accents',
      'Geothermal dual zone system',
    ],
    images: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/qTKo374tAMCnzY2sNP1ebg/68-Aug_09_2025_02_03pm-ivcN.jpg',
        alt: 'The Geothermal Tamarack Estate exterior with ZIP sheathing and gabled rooflines against mountain backdrop',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/hC7UBHQRAx2aB5vGA9knX4/17-May_14_2025_06_54pm-Ecwd.jpg',
        alt: 'Foundation formwork and hillside excavation with crew on site',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/uqjoUfgyRZuRM9ssYxhske/18-May_22_2025_06_34pm-kSq9.jpg',
        alt: 'Poured concrete foundation walls with waterproofing and valley views',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/dscroCyxebfWSqxDinnZ78/40-Jun_23_2025_05_39pm-3Lc2.jpg',
        alt: 'Floor joist framing with steel columns and panoramic mountain views',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/dH3Wa9qC1H8RF9GAXFr7e7/351-Mar_12_2026_07_01pm-X8A3.jpg',
        alt: 'Covered deck with cedar ceiling, infrared heaters, and forest views',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/5JsWCetD4f4xVLrus8hEvC/392-Mar_18_2026_02_20am-tEhV.jpg',
        alt: 'Garage ceiling with hexagonal LED light installation',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/71Jcet3nPBSK4ouKMjvfgC/397-Mar_25_2026_01_09pm-yRLB.jpg',
        alt: 'Hallway with knotty alder doors, oak hardwood floors, and glass-paneled closet',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/oLu8y871cx8ue6vykjWaNu/401-Mar_25_2026_01_11pm-xiN7.jpg',
        alt: 'Primary bathroom with floating walnut vanity, vessel sinks, and organic-shaped mirrors',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/3VUNAytN6Zzm78Ba1UXk3a/403-Mar_25_2026_01_12pm-D2BZ.jpg',
        alt: 'Primary bath with freestanding tub, walk-in shower, and microcement floors',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/87utJReDMZbHDYGACLeHpr/407-Mar_25_2026_01_13pm-o7QL.jpg',
        alt: 'Laundry room with walnut cabinetry, quartz counters, and natural stone tile',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/rPmbeGKF94W1TtdqvvUwnJ/409-Mar_25_2026_07_32pm-kUsM.jpg',
        alt: 'Kitchen with waterfall quartz island, under-cabinet lighting, and oak hardwood floors',
      },
    ],
  },
]
